import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, withModifiers as _withModifiers, withCtx as _withCtx } from "vue"

const _hoisted_1 = ["data-rotation", "title"]
const _hoisted_2 = {
  key: 0,
  class: "video-placeholder"
}
const _hoisted_3 = {
  key: 1,
  class: "rotation-hint",
  "aria-live": "polite"
}
const _hoisted_4 = {
  key: 0,
  class: "video-controls"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_VideoCameraOutlined = _resolveComponent("VideoCameraOutlined")!
  const _component_MinusOutlined = _resolveComponent("MinusOutlined")!
  const _component_a_button = _resolveComponent("a-button")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["video-panel", {
      'user-speaking': _ctx.isUserSpeaking,
      'portrait-mode': _ctx.isPortraitMode,
      'mount-only': _ctx.mountOnly,
    }]),
    ref: "videoPanelRef"
  }, [
    _createElementVNode("div", {
      class: _normalizeClass(["video-container", { 'can-rotate': _ctx.isConnected }]),
      "data-rotation": _ctx.rotationDeg,
      title: 
        _ctx.isConnected
          ? `点击调整画面方向（当前 ${_ctx.rotationDeg}°）`
          : undefined
      ,
      onMousedown: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.startDrag && _ctx.startDrag(...args))),
      onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.handleVideoClick && _ctx.handleVideoClick(...args)))
    }, [
      _cache[5] || (_cache[5] = _createElementVNode("div", { id: "local-player" }, null, -1)),
      (!_ctx.isConnected)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _createVNode(_component_VideoCameraOutlined, { class: "camera-off-icon" }),
            _cache[4] || (_cache[4] = _createElementVNode("p", null, "点击\"开启视频通话\"开始", -1))
          ]))
        : _createCommentVNode("", true),
      (_ctx.isConnected && _ctx.rotationHintVisible)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, _toDisplayString(_ctx.rotationDeg) + "° ", 1))
        : _createCommentVNode("", true)
    ], 42, _hoisted_1),
    (_ctx.isPortraitMode)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _createVNode(_component_a_button, {
            class: "minimize-video-btn",
            shape: "circle",
            onClick: _cache[2] || (_cache[2] = _withModifiers(($event: any) => (_ctx.$emit('minimize')), ["stop"]))
          }, {
            icon: _withCtx(() => [
              _createVNode(_component_MinusOutlined)
            ]),
            _: 1
          })
        ]))
      : _createCommentVNode("", true),
    (_ctx.isPortraitMode)
      ? (_openBlock(), _createElementBlock("div", {
          key: 1,
          class: "resize-handle",
          onMousedown: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.startResize && _ctx.startResize(...args)))
        }, null, 32))
      : _createCommentVNode("", true)
  ], 2))
}